<div name="header" class="nav-header border-bottom-2 border-primary flex justify-content-between" [ngClass]="{'nav-open': !navOpen, 'nav-collapsed': navOpen}">
    <div name="tabs" class="flex justify-content-start" id="tabs-div">
        <div *ngFor="let tab of tabs;let i = index" 
            class="text-sm w-max p-1 px-3 border-x-2 div-button border-primary tab" (click)="changeTab(i)" (keydown.enter)="changeTab(i)"
            [ngClass]="{'selected-tab': selectedTabIndex  == i}">
            {{ tab }}
        </div>
    </div>
    <div name="search" class="grid m-0 justify-content-end w-3 mr-2">
        <p-dropdown class="col-4 p-0 my-1" styleClass="text-sm" [options]="searchTypeOptions" placeholder="Search Type" [autoDisplayFirst]="false"></p-dropdown>
        <input class="col-8 py-0 px-1 p-inputText text-sm border-1 border-primary my-1" (keydown.enter)="findAndRedirect()" placeholder="Search Input" />
    </div>
</div>